import type { RouteDef } from '../router';
import { ssrBodyFor, browserPath } from '../router';
import { allCountries } from '../data/prices';

/**
 * /data-price-index — SPA side of the GEO-flagship price index.
 *
 * The full page body is server-rendered (backend/src/util/price-index-body.ts,
 * computed live from prices.json). Mirrors the FIXED agent-landing pattern:
 * render() is IDEMPOTENT — if the SSR body is already in the DOM it is kept
 * (the router re-resolves on Auth.onChange/popstate; an unconditional reload
 * here produced the agent-landing infinite reload loop, fixed 2026-07-07).
 * Genuine SPA-nav from another route triggers ONE guarded full load so the
 * server renders the body.
 */
const NAV_GUARD_KEY = 'roamzy:price-index-nav';

export const priceIndexRoute: RouteDef = {
  path: '/data-price-index',
  routeType: 'article',
  metaTitle: `eSIM Data Price Index — Live Per-MB Rates, ${allCountries.length} Countries | Roamzy`,
  metaDesc: `The only per-megabyte mobile-data price index from first-party billing data: live rates for ${allCountries.length} countries, regional medians, rankings, CSV/JSON download.`,
  prerenderMarker: '.price-index-route',
  hydrate: () => {
    try { sessionStorage.removeItem(NAV_GUARD_KEY); } catch { /* private mode */ }
    return '';
  },
  render() {
    const ssr = ssrBodyFor('.price-index-route');
    if (ssr !== null) return ssr;
    try {
      if (sessionStorage.getItem(NAV_GUARD_KEY) !== browserPath()) {
        sessionStorage.setItem(NAV_GUARD_KEY, browserPath());
        window.location.assign(browserPath());
        return '';
      }
      sessionStorage.removeItem(NAV_GUARD_KEY);
    } catch {
      window.location.assign(browserPath());
      return '';
    }
    return `<section class="section"><div class="container">`
      + `<p><a href="${browserPath()}">Open the eSIM Data Price Index</a></p></div></section>`;
  },
};
